import { AccountConstants, AppConstants } from '../../constants/constants';
const initState = {
    isLogin: false, //dev
    current: null,
    permissions: [],
    table: {}
};

const accountReducer = (state = initState, action) => {
    switch (action.type) {
        case AccountConstants.SIGN_IN: {
            
            let current = action.data;
            const urlprefix = sessionStorage.getItem(AppConstants.FS_URL_PREFIX) ? decodeURIComponent(sessionStorage.getItem(AppConstants.FS_URL_PREFIX)) : null;
            const signature = sessionStorage.getItem(AppConstants.FS_URL_SIGNATURE) ? decodeURIComponent(sessionStorage.getItem(AppConstants.FS_URL_SIGNATURE)) : null;
            current.avatar = current.avatar
                ? `${urlprefix}${current.avatar}?${signature}`
                : null; // '/images/mock1.jpg';

            return {
                ...state,
                isLogin: true,
                current: current
            };
        }
        case AccountConstants.GET_ACCOUNTS_TABLE_DATA: {
            return {
                ...state,
                table: action.data
            };
        }
        case AccountConstants.LOGOUT: {
            return {
                ...state,
                isLogin: false,
                current: null
            };
        }
        case AccountConstants.GET_PERMISSIONS: {
            return {
                ...state,
                permissions: action.payload
            };
        }
        case AccountConstants.UPDATE_CURRENT_AVATAR: {
            return {
                ...state,
                current: {
                    ...state.current,
                    avatar: action.payload
                }
            };
        }
        case AccountConstants.UPDATE_ACCOUNT_BRANDING_DATA: {
             
             if (state.current.account_id === action.payload.account_id) {
                return {
                    ...state,
                    current: {
                        ...state.current,
                        appLogo: action.payload.app_logo,
                        primaryColor: action.payload.primary_color,
                        secondaryColor: action.payload.secondary_color,
                        tertiaryColor: action.payload.tertiary_color,
                        quaternaryColor: action.payload.quaternary_color,
                    }
                };
            }
            else{return state}
        }
        default:
            return state;
    }
};

export default accountReducer;
